import React from "react";
import classes from "./TipsInfo.module.css";
import constants from "../../../../globalization";
import PopupHeader from "../../../Fireboard/components/PopupHeader";

const TipsInfo = (props) => {
  const {
    tipsData: {
      totalSales,
      totalTips,
      totalTipPercent,
      oneDineSales,
      oneDineTips,
      oneDineTipPercent,
    },
    onClose,
    currency,
  } = props || {};

  return (
    <div className={classes.container}>
      <PopupHeader title="Server Tips Information" onClose={onClose} />
      <div className={classes.itemsContainer}>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>{constants.totalSales}</span>
          <span className={classes.valueTextStyle}>{currency}{totalSales}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>{constants.totalTips}</span>
          <span className={classes.valueTextStyle}>{currency}{totalTips}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>{constants.totalTipPercent}</span>
          <span className={classes.valueTextStyle}>{totalTipPercent}%</span>
        </div>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>{constants.oneDineSales}</span>
          <span className={classes.valueTextStyle}>{currency}{oneDineSales}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>{constants.oneDineTips}</span>
          <span className={classes.valueTextStyle}>{currency}{oneDineTips}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>{constants.oneDineTipPercent}</span>
          <span className={classes.valueTextStyle}>{oneDineTipPercent}%</span>
        </div>
      </div>
    </div>
  );
};

export default TipsInfo;
